module.exports = __webpack_public_path__ + "img/login-img-hw.7caaf5ad.png";